import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonRow, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBackOutline, callOutline, personOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import './Entrar.css';

type Props = {
  nome: any;
  celular: any;
  logado: any;
  closeAction: Function;
  closeActionSimple: Function;
}

const Entrar: React.FC<Props> = (props: Props) => {

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [telefone, setTelefone] = useState("");
  const [nome, setNome] = useState("");

  const campoTelefone = useRef<any>(null);
  const ENTER_KEY_CODE = 13;

  useEffect(() => {
    console.log("entrou confirme celular", props.celular);
    if (props.celular) {
      setTelefone(formatarCelular(props.celular));
    }
    if (props.nome) {
      setNome(props.nome);
    }

  }, []);

  function formatarCelular(valor: string): string {
    // Remove tudo que não for número
    let numeros = valor.replace(/\D/g, '');

    // Remove o DDI '55' se estiver no início
    numeros = numeros.slice(2);

    // Aplica a máscara conforme o comprimento
    if (numeros.length >= 11) {
      return numeros.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
    } else if (numeros.length >= 10) {
      return numeros.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
    } else {
      return numeros;
    }
  }



  function onKeyUpTelefone(e: any) {
    e.persist();
    e.preventDefault();



    // if (e.keyCode === ENTER_KEY_CODE) {
    //   if (e.target.value.length >= 15) {

    //     let validadorCelular = /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/;

    //     if (!validadorCelular.test(e.target.value)) {
    //       setTextToast("Celular Inválido.");
    //       setShowToast(true);
    //     }

    //     e.target.value = e.target.value.substring(0, 15);
    //     setTelefone(e.target.value.substring(0, 15));

    //     const telefoneFormatado = "55" + e.target.value.replace("(", "").replace(")", "").replace(" ", "").replace("-", "");

    //     props.closeAction(telefoneFormatado);


    //   }
    // }

    if (e.target.value.length > 15) {
      e.target.value = e.target.value.substring(0, 15);
      setTelefone(e.target.value.substring(0, 15));
      return;
    }

    let val = e.target.value;
    var telVal = val.replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{4})(\d+?)$/, "$1");
    //console.log(cpfval);
    setTelefone(telVal);
  }

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.closeActionSimple()}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Identifique-se</IonTitle>

        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>

        <div className="confirmar-celular-titulo1">
          Informe seus dados
        </div>
        <div className="confirmar-celular-titulo2">
          Informe seu <span className="confirmar-celular-whatsapp-text">WhatsApp</span> para acompanhar seus pedidos e aproveitar benefícios.
        </div>

        <IonItem lines="none" className="input-item">
          <IonIcon slot="start" icon={personOutline} />
          <IonInput
            value={nome}
            disabled={props.logado}
            maxlength={50}
            placeholder="Digite seu nome"
            onIonInput={(e: any) => setNome(e.target.value)}
          ></IonInput>
        </IonItem>

        <IonItem lines="none" className="input-item">
          <IonIcon slot="start" icon={callOutline} />
          <IonInput
            ref={(ref) => campoTelefone.current = ref}
            type="tel"
            maxlength={15}
            placeholder="Seu número com DDD"
            required
            value={telefone}
            disabled={props.logado}
            onKeyUp={onKeyUpTelefone}
            onIonInput={(e: any) => setTelefone(e.target.value)}
          />
        </IonItem>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

      </IonContent>

      <IonFooter>
        <IonToolbar>
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButton
                  style={{ height: "46px", fontSize: "18px", backgroundColor: "#4CAF50", color: "#fff" }}
                  onClick={async () => {

                    const nomeValido = nome.trim().length >= 2;
                    const somenteDigitos = telefone.replace(/\D/g, "");
                    const telefoneCom55 = "55" + somenteDigitos;
                    const telefoneValido = telefoneCom55.startsWith("55") && (telefoneCom55.length === 13);

                    if (!nomeValido) {
                      setTextToast("Digite um nome válido.");
                      setShowToast(true);
                      return;
                    }

                    if (!telefoneValido) {
                      setTextToast("Digite um celular válido.");
                      setShowToast(true);
                      return;
                    }

                    props.closeAction(nome, telefoneCom55);



                  }}
                  expand="block"
                  type="submit"
                >
                  Continuar
                </IonButton>

              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>


    </>
  );
};

export default ({ nome, celular, logado, closeAction, closeActionSimple }: { nome: any, celular: any, logado: any, closeAction: Function, closeActionSimple: Function }) => (
  <Entrar nome={nome} celular={celular} logado={logado} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </Entrar>
)
